import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';

import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

import { ApiService } from '../../../services/api.service';
import { OrderCreateFormComponent } from '../../../components/order/order-create-form/order-create-form.component';
import { PageHeaderComponent } from "../../../components/page-header/page-header.component";

@Component({
  selector: 'app-orders-index',
  standalone: true,
  imports: [
    CommonModule,
    LoaderComponent,
    TableGuruComponent,
    PageHeaderComponent
],
  templateUrl: './order-index.component.html',
  styleUrl: './order-index.component.scss'
})
export class OrderIndexComponent implements OnInit {
  items: [] = [];
  private modalService = inject(NgbModal);
  reloadItems: boolean = false;

  orders: [] = [];

  addFormReference = OrderCreateFormComponent;

  constructor(
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.apiService.get("/office/orders").then((data: any) => {
      this.orders = data;
      console.log(data)
    })
  }

  openModal(item: any) {
    let self = this;
    const modalRef = this.modalService.open(this.addFormReference, { size: 'xl' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.result.then((result) => {
      self.reloadItems = true;

      setTimeout(() => {
        self.reloadItems = false;
      }, 200);
    });
  }
}
